import React from 'react';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  dark?: boolean;
}

const Logo: React.FC<LogoProps> = ({ className = '', size = 'md', dark = false }) => {
  const heights = {
    sm: 'h-10',
    md: 'h-14',
    lg: 'h-20',
  };

  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src="/logo.png" 
        alt="Rinova Group" 
        className={`${heights[size]} w-auto ${dark ? 'brightness-0 invert' : ''}`}
      />
    </div>
  );
};

export default Logo;
